import AuthApi from '../api/auth';

const EMAIL_KEY = 'EHS.PCMH.AUTH.EMAIL';
const TOKEN_KEY = 'EHS.PCMH.AUTH.TOKEN';
const USER_KEY = 'EHS.PCMH.USER';
const REFRESH_TOKEN_KEY = 'EHS.PCMH.AUTH.REFRESH_TOKEN';
const ID_TOKEN_KEY = 'EHS.PCMH.AUTH.ID_TOKEN';

export const AuthService = {
  getEmail() {
    const email = localStorage.getItem(EMAIL_KEY);
    if (!email) {
      const user = this.getUser();
      if (user) {
        return user.email;
      } else {
        return null;
      }
    }
    return email;
  },

  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },
  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },
  getIdToken() {
    return localStorage.getItem(ID_TOKEN_KEY);
  },

  getUser() {
    const user = localStorage.getItem(USER_KEY);
    return JSON.parse(user);
  },

  isAuthenticated() {
    let token = this.getToken();
    if (!token) {
      return false;
    }
    return true;
  },

  async isPayer() {
    const user = this.getUser();
    let payerStatus = false;
    if (user) {
      const { data } = await AuthApi.isPayer(user.email);
      if (data) {
        payerStatus = data.isPayer;
      }
    }
    return payerStatus;
  },

  setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
  },
  setRefreshToken(token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  },
  setIdToken(token) {
    localStorage.setItem(ID_TOKEN_KEY, token);
  },

  setUser(user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },

  setEmail(email) {
    localStorage.setItem(EMAIL_KEY, email);
  },

  signIn(token, user, refreshToken, idToken) {
    this.setToken(token);
    this.setRefreshToken(refreshToken);
    this.setIdToken(idToken);
    this.setUser(user);
    this.setEmail(user.email);
  },

  signOut() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(ID_TOKEN_KEY);
  },
};



// WEBPACK FOOTER //
// ./src/state/auth.service.js